<div class="border-steel-20 mat-elevation-z3 m-8 max-w-2xl rounded-md border p-4" *transloco="let t; read: 'fallbackPages.generic'">
  <rma-star-rating class="mb-2" [allowZeroStars]="true" [overallStars]="0" />
  <h1 class="mb-2 text-2xl font-bold">{{ t('title') }}</h1>

  <ol class="text-steel-70 mb-4 ml-8 list-decimal pl-4">
    <li>{{ t('subtitle-1') }}</li>
    <li>{{ t('subtitle-2') }}</li>
  </ol>

  <div class="flex flex-col space-y-5 sm:flex-row sm:space-x-5 sm:space-y-0">
    <a [href]="'mailto:' + supportEmail" mat-stroked-button color="primary">
      {{ t('action.contact') }}
    </a>

    <a routerLink="/" mat-flat-button color="primary">
      {{ t('action.home') }}
    </a>
  </div>
</div>
